// src/pages/About.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div>
      {/* HERO */}
      <section className="bg-gradient-to-br from-pink-50 via-white to-purple-50 py-20 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800">
          Empowering Women to Take Control of
          <br/> Hormonal Health
        </h1>
        <p className="mt-6 max-w-2xl mx-auto text-gray-600 text-lg">
          Guides, products, and wellness tools carefully curated for PCOS, hormone balance, and overall wellness.
        </p>
      </section>

      {/* OUR STORY */}
      <section className="max-w-4xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Story</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          We started this platform because women with PCOS and hormonal imbalances often struggle to find reliable guidance. 
          After years of research, trial, and personal experience, we realized there was a need for a trustworthy hub for wellness.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Our mission is to provide evidence-based resources, curated supplements, and practical lifestyle tips to help women feel confident, energetic, and balanced every day.
        </p>
      </section>

      {/* WHAT WE OFFER */}
      <section className="bg-gray-50 py-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">What We Offer</h2>
          <p className="text-gray-600 mb-10">
            From curated supplements to PCOS-friendly fitness tools, lifestyle guides, and research-backed tips, we provide everything to support your hormonal health journey.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow p-6">
              <h3 className="font-semibold text-lg mb-2">Curated Products</h3>
              <p className="text-gray-600 text-sm">PCOS-friendly supplements, books, and wellness tools recommended for your needs.</p>
            </div>
            <div className="bg-white rounded-2xl shadow p-6">
              <h3 className="font-semibold text-lg mb-2">Wellness Guides</h3>
              <p className="text-gray-600 text-sm">Step-by-step routines, fitness plans, and lifestyle advice backed by research.</p>
            </div>
            <div className="bg-white rounded-2xl shadow p-6">
              <h3 className="font-semibold text-lg mb-2">Evidence-Based Advice</h3>
              <p className="text-gray-600 text-sm">Reliable insights supported by studies and expert recommendations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST / CTA */}
      <section className="max-w-7xl mx-auto px-6 py-16 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Join Us on Your Wellness Journey</h2>
        <p className="text-gray-600 mb-6">
          Explore our top products and expert guides to feel confident in your hormonal health.
        </p>
        <Link
          to="/category/all"
          className="inline-block bg-pink-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-pink-600 transition"
        >
          Browse Products
        </Link>
      </section>

      {/* FOOTER NOTE */}
      <section className="bg-pink-50 py-12 text-center px-6">
        <p className="text-gray-700 max-w-3xl mx-auto text-sm">
          Our content is for educational purposes only and is not a substitute for professional medical advice. Always consult a healthcare professional regarding supplements, exercise, and health decisions.
        </p>
      </section>
    </div>
  );
}
